module.exports = __webpack_public_path__ + "static/media/img2-1.570a5be7.png";